import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App.tsx";
import "./index.css";
import { deleteLastSlashs } from "@shared-ui/utils/url.ts";
import { registerServiceWorkerAutoReload } from "@shared-ui/utils/registerServiceWorkerAutoReload";

const basename = deleteLastSlashs(import.meta.env.BASE_URL);

// PRODUCT_DEV-471: リリース後の自動反映 (3プロダクト共通)
registerServiceWorkerAutoReload();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
